module.exports = __webpack_public_path__ + "img/solution-ethernet-system-pic.2873a7d7.png";